import { WEBCHAT } from 'Constants/normalize-module';
import { consultSchema } from 'Schemas/schemas';
import { CONSULT_ACCEPTED, CONSULT_FINISHED } from 'Constants/consults';
import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function consultDetails(consultId, params) {
  return {
    types: [
      ACTION_TYPES.CONSULT_DETAILS_REQUESTED,
      ACTION_TYPES.CONSULT_DETAILS_SUCCEED,
      ACTION_TYPES.CONSULT_DETAILS_FAILED,
    ],
    promise: client => client.get(`/consults/${consultId}`, { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function consultFinish(doctorId, consultId, extraData = {}) {
  return {
    types: [
      ACTION_TYPES.CONSULT_FINISH_REQUESTED,
      ACTION_TYPES.CONSULT_FINISH_SUCCEED,
      ACTION_TYPES.CONSULT_FINISH_FAILED,
    ],
    promise: client =>
      client.patch(`/doctors/${doctorId}/consults/${consultId}`, {
        status: CONSULT_FINISHED,
        ...(extraData || {}),
      }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function consultAccepted(doctorId, consultId, body, deviceId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_ACCEPT_REQUESTED,
      ACTION_TYPES.CONSULT_ACCEPT_SUCCEED,
      ACTION_TYPES.CONSULT_ACCEPT_FAILED,
    ],
    promise: client =>
      client.patch(`/doctors/${doctorId}/consults/${consultId}`, body, {
        headers: {
          'device-id': deviceId,
        },
      }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function getOngoingConsult(doctorId, patientId, params) {
  return {
    types: [
      ACTION_TYPES.CONSULT_GET_ONGOING_REQUESTED,
      ACTION_TYPES.CONSULT_GET_ONGOING_SUCCEED,
      ACTION_TYPES.CONSULT_GET_ONGOING_FAILED,
    ],
    promise: client =>
      client.get(`/doctors/${doctorId}/patients/${patientId}/consults`, { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function consultUpdate(doctorId, consultId, body) {
  return {
    types: [
      ACTION_TYPES.CONSULT_UPDATE_REQUESTED,
      ACTION_TYPES.CONSULT_UPDATE_SUCCEED,
      ACTION_TYPES.CONSULT_UPDATE_FAILED,
    ],
    promise: client => client.patch(`/doctors/${doctorId}/consults/${consultId}`, body),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function registerNotificationTokenConsult(notificationToken) {
  return {
    types: [
      ACTION_TYPES.CONSULT_REGISTER_TOKEN_REQUESTED,
      ACTION_TYPES.CONSULT_REGISTER_TOKEN_SUCCEED,
      ACTION_TYPES.CONSULT_REGISTER_TOKEN_FAILED,
    ],
    promise: client =>
      client.post('/notification/register-token', { deviceToken: notificationToken }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function unregisterNotificationTokenConsult(deviceToken) {
  return {
    types: [
      ACTION_TYPES.CONSULT_UNREGISTER_TOKEN_REQUESTED,
      ACTION_TYPES.CONSULT_UNREGISTER_TOKEN_SUCCEED,
      ACTION_TYPES.CONSULT_UNREGISTER_TOKEN_FAILED,
    ],
    promise: client => client.delete(`/notification/register-token?device_token=${deviceToken}`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

// consult pending
export function getConsultsPending(params = {}, isLoadMore = false) {
  return {
    types: [
      ACTION_TYPES.CONSULTS_PENDING_GET_REQUESTED,
      ACTION_TYPES.CONSULTS_PENDING_GET_SUCCEED,
      ACTION_TYPES.CONSULTS_PENDING_GET_FAILED,
    ],
    promise: client => client.get('/consults/pending-consults', { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: [consultSchema],
      },
      module: WEBCHAT,
      isLoadMore,
    },
  };
}

export function getConsultsPendingStats() {
  return {
    types: [
      ACTION_TYPES.CONSULTS_PENDING_STATS_REQUESTED,
      ACTION_TYPES.CONSULTS_PENDING_STATS_SUCCEED,
      ACTION_TYPES.CONSULTS_PENDING_STATS_FAILED,
    ],
    promise: client => client.get('/consults/pending-consults/stats'),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function acceptConsultPending(doctorId, consultId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_PENDING_ACCEPT_REQUESTED,
      ACTION_TYPES.CONSULT_PENDING_ACCEPT_SUCCEED,
      ACTION_TYPES.CONSULT_PENDING_ACCEPT_FAILED,
    ],
    promise: client =>
      client.patch(`/doctors/${doctorId}/consults/${consultId}`, {
        status: CONSULT_ACCEPTED,
        fromPool: 1,
      }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function resetPendingState() {
  return {
    type: ACTION_TYPES.CONSULT_PENDING_RESET_STATE,
    payload: {},
  };
}

export function removePendingConsult(consultId) {
  return {
    type: ACTION_TYPES.CONSULT_PENDING_REMOVE,
    payload: consultId,
  };
}

export function addPendingConsult(consultId) {
  return {
    type: ACTION_TYPES.CONSULT_PENDING_ADDED,
    payload: consultId,
  };
}

export function increasePendingConsultStats(increaseNumber = 0) {
  return {
    type: ACTION_TYPES.CONSULT_PENDING_STATS_INCREASE_TOTAL,
    payload: increaseNumber,
  };
}

export function decreasePendingConsultStats(decreaseNumber = 0) {
  return {
    type: ACTION_TYPES.CONSULT_PENDING_STATS_DECREASE_TOTAL,
    payload: decreaseNumber,
  };
}

export function getConsultDetailsInPool(consultId, params) {
  return {
    types: [
      ACTION_TYPES.CONSULT_DETAILS_POOL_REQUESTED,
      ACTION_TYPES.CONSULT_DETAILS_POOL_SUCCEED,
      ACTION_TYPES.CONSULT_DETAILS_POOL_FAILED,
    ],
    promise: client => client.get(`/consults/${consultId}`, { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function resetConsultStatus() {
  return {
    type: ACTION_TYPES.CONSULT_STATUS_RESET_STATE,
    payload: '',
  };
}

export function getConsultMember(consultId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_MEMBER_GET_REQUESTED,
      ACTION_TYPES.CONSULT_MEMBER_GET_SUCCEED,
      ACTION_TYPES.CONSULT_MEMBER_GET_FAILED,
    ],
    promise: client => client.get(`/consults/${consultId}/members`),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      consultId,
    },
  };
}

export function getConsultDetails(consultId, params) {
  return {
    types: [
      ACTION_TYPES.CONSULT_GET_DETAILS_REQUESTED,
      ACTION_TYPES.CONSULT_GET_DETAILS_SUCCEED,
      ACTION_TYPES.CONSULT_GET_DETAILS_FAILED,
    ],
    promise: client => client.get(`/consults/${consultId}`, { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function createConsult(doctorId, body) {
  return {
    types: [
      ACTION_TYPES.CONSULT_CREATE_REQUESTED,
      ACTION_TYPES.CONSULT_CREATE_SUCCEED,
      ACTION_TYPES.CONSULT_CREATE_FAILED,
    ],
    promise: client => client.post(`/doctors/${doctorId}/consults`, body),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function createFollowup(doctorId, body) {
  return {
    types: [
      ACTION_TYPES.CONSULT_FOLLOWUP_REQUESTED,
      ACTION_TYPES.CONSULT_FOLLOWUP_SUCCEED,
      ACTION_TYPES.CONSULT_FOLLOWUP_FAILED,
    ],
    promise: client => client.post(`/doctors/${doctorId}/consults`, body),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: consultSchema,
      },
      module: WEBCHAT,
    },
  };
}

export function selectConsultPending(consultId) {
  return {
    type: ACTION_TYPES.CONSULT_PENDING_ACTIVE,
    payload: consultId,
  };
}

export function consultResetState() {
  return {
    type: ACTION_TYPES.CONSULT_RESET_STATE,
  };
}

export function consultSetMainProvider(doctorId, consultId, body) {
  return {
    types: [
      ACTION_TYPES.CONSULT_SET_MAIN_PROVIDER_REQUESTED,
      ACTION_TYPES.CONSULT_SET_MAIN_PROVIDER_SUCCEED,
      ACTION_TYPES.CONSULT_SET_MAIN_PROVIDER_FAILED,
    ],
    promise: client =>
      client.patch(`/doctors/${doctorId}/consults/${consultId}/set-main-doctor`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function getConsultationClinic(doctorId, params) {
  return {
    types: [
      ACTION_TYPES.CONSULTATION_CLINIC_GET_REQUESTED,
      ACTION_TYPES.CONSULTATION_CLINIC_GET_SUCCEEDED,
      ACTION_TYPES.CONSULTATION_CLINIC_GET_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/consultation-clinic`, { params }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function consultGenClinicalNote(consultId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_GEN_CLINICAL_NOTE_REQUESTED,
      ACTION_TYPES.CONSULT_GEN_CLINICAL_NOTE_SUCCEED,
      ACTION_TYPES.CONSULT_GEN_CLINICAL_NOTE_FAILED,
    ],
    promise: client => client.post(`/consults/${consultId}/generate-clinical-note`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function switchConsultToOtherClinic(consultId, toClinicId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_SWITCH_TO_OTHER_CLINIC_REQUESTED,
      ACTION_TYPES.CONSULT_SWITCH_TO_OTHER_CLINIC_SUCCEED,
      ACTION_TYPES.CONSULT_SWITCH_TO_OTHER_CLINIC_FAILED,
    ],
    promise: client => client.post(`/consults/${consultId}/switch-clinic`, { toClinicId }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function resetSwitchClinicState() {
  return {
    type: ACTION_TYPES.CONSULT_SWITCH_TO_OTHER_CLINIC_RESET_STATE,
  };
}

export function getConsultPatient(consultId, patientId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_PATIENT_GET_REQUESTED,
      ACTION_TYPES.CONSULT_PATIENT_GET_SUCCEED,
      ACTION_TYPES.CONSULT_PATIENT_GET_FAILED,
    ],
    promise: client => client.get(`/consults/${consultId}/patients/${patientId}`),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      consultId,
      patientId,
    },
  };
}
